<template>
    <div class="chatbot-block-editor run-javascript">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">JavaScript Kodu</div>
            <div class="code-editor-wrapper">
                <div class="code-editor-header">
                    <div class="tips">
                        <div class="tip">
                            <md-icon>info</md-icon>
                            <span>Bu blok, kullanıcının yazdığı JavaScript kodunu çalıştırır.</span>
                        </div>
                        <div class="tip">
                            <md-icon>warning</md-icon>
                            <span>Güvenlik nedenlerinden dolayı bazı JavaScript özellikleri kısıtlanmıştır.</span>
                        </div>
                    </div>
                    <div class="actions d-flex gap-5">
                        <a-button type="primary" class="fullscreen-btn" @click="toggleFullScreen" style="margin-right: 10px">
                            <i class="material-icons" style="font-size: 15px; margin-right: 5px">
                                {{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}
                            </i>
                            {{ isFullScreen ? 'Çıkış' : 'Tam Ekran' }}
                        </a-button>
                        <a-button type="primary" class="ai-assistant-btn" @click="showPromptWizard">
                            <img src="/static/img/copilot.png" width="15" height="15" style="margin-right: 5px" />
                            Supsis Asistan
                        </a-button>
                    </div>
                </div>

                <div class="code-editor">
                    <div class="available-libraries">
                        <span>Kullanılabilir Kütüphaneler:</span>
                        <code>moment</code>, <code>lodash (_)</code>, <code>axios (sadece get ve post)</code>
                    </div>

                    <div class="available-variables">
                        <span>Kullanılabilir Değişkenler:</span>
                        <code>chatbot.readAttribute</code>,
                        <code>chatbot.sendMessage</code>,
                        <code>chatbot.jump</code>,
                        <code>chatbot.askAssistant</code>,
                        <code>chatbot.platform</code>,
                        ve daha fazlası (chatbot. yazarak tüm metodları görebilirsiniz)
                    </div>

                    <div class="attribute-help">
                        <span>Chatbot Değişkenleri:</span>
                        <code>name</code>, <code>email</code>, <code>phone</code>, <code>message</code>,
                        <code>block.blockId.field</code> şeklinde kullanılabilir.
                    </div>

                    <div id="monaco-editor-container-chatbot" class="monaco-editor-container" :class="{ 'fullscreen-editor': isFullScreen }"></div>
                </div>

                

                
            </div>
        </div>

        <!-- JavaScript Asistan Modal -->
        <a-modal
            v-model="showJsAssistant"
            title="JavaScript Asistanı"
            :width="800"
            :footer="null"
            @cancel="handleAssistantClose"
        >
            <div class="js-assistant-modal">
                <div class="js-assistant-description">
                    <h4>JavaScript kodunu yapay zeka ile oluşturun</h4>
                    <p>
                        Yapmak istediğiniz işlemi doğal dilde açıklayın, Supsis Asistan sizin için JavaScript kodunu
                        oluştursun.
                    </p>

                    <div class="js-capabilities">
                        <div class="capabilities-header">
                            <a-icon type="bulb" />
                            <h5>Yapabilecekleriniz:</h5>
                        </div>
                        <div class="capabilities-content">
                            <div class="capability-item">
                                <i class="material-icons">chat</i>
                                <span>Mesaj gönderme</span>
                            </div>
                            <div class="capability-item">
                                <i class="material-icons">transfer_within_a_station</i>
                                <span>Chat transfer</span>
                            </div>
                            <div class="capability-item">
                                <i class="material-icons">close</i>
                                <span>Chat kapatma</span>
                            </div>
                            <div class="capability-item">
                                <i class="material-icons">http</i>
                                <span>API istekleri</span>
                            </div>
                            <div class="capability-item">
                                <i class="material-icons">person</i>
                                <span>Kişi işlemleri</span>
                            </div>
                            <div class="capability-item">
                                <i class="material-icons">settings</i>
                                <span>Attribute güncelleme</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="prompt-container">
                    <s2-textarea
                        v-model="jsPrompt"
                        :rows="4"
                        :placeholder="'Örnek: Kullanıcı adını al, selamla ve ardından email adresini kaydet'"
                        ref="promptTextarea"
                    />

                    <div class="example-prompts">
                        <div
                            class="example-prompt"
                            @click="selectExamplePrompt('Kullanıcı adını al, mesajla selamla ve VIP olarak etiketle')"
                        >
                            <a-icon type="user" />
                            <span>Kullanıcı selamlama ve etiketleme</span>
                        </div>
                        <div
                            class="example-prompt"
                            @click="selectExamplePrompt('Email adresi geçerli mi kontrol et, geçerli ise kaydet')"
                        >
                            <a-icon type="mail" />
                            <span>Email doğrulama ve kaydetme</span>
                        </div>
                        <div
                            class="example-prompt"
                            @click="selectExamplePrompt('API ile sipariş durumunu kontrol et ve kullanıcıya bildir')"
                        >
                            <a-icon type="api" />
                            <span>API ile sipariş kontrolü</span>
                        </div>
                    </div>

                    <div class="buttons-container">
                        <a-button @click="handleAssistantClose">İptal</a-button>
                        <a-button type="primary" :loading="assistantLoading" @click="generateJavaScriptCode">
                            Kod Oluştur
                        </a-button>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import _ from "lodash";
import * as monaco from "monaco-editor";
import CoPilot from "../../../../../../utils/CoPilot";
import S2Textarea from "../../../../../../components/S2Textarea.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import systemAttributes from "../../../utils/systemAttributes";
import flatDiagram from "../../../utils/flatDiagram";
import { createCompletionItemProviderForChatbot } from "../../../utils/createCompletionItemProviderForChatbot";

export default {
    name: "RunJavaScript",
    components: {
        S2Textarea,
    },
    props: ["value", "blockId"],
    data() {
        return {
            payload: _.cloneDeep(this.value) || {
                code: "",
                exampleResult: {},
            },
            cancels: [],
            editor: null,
            showJsAssistant: false,
            jsPrompt: "",
            assistantLoading: false,
            moduleCache: [],
            hasUnsavedChanges: false,
            originalCode: "",
            isFullScreen: false,
            chatbotAttributes: [],
        };
    },
    computed: {
        ...mapGetters({
            board: "CB/board",
        }),
        ...mapState({
            users: (state) => state.user.users?.data || [],
            me: (state) => state.auth.user.user?._id,
            channels: (state) => state.channel.channels || [],
        }),
    },
    async created() {
        // Modülleri yükle
        try {
            await this.$store.dispatch("module/syncModules");
            if (this.$store.state.module?.modules) {
                this.moduleCache = this.$store.state.module.modules;
            }
        } catch (error) {
            console.error("Modülleri sync ederken hata oluştu:", error);
        }
    },
    mounted() {
        this.originalCode = this.payload.code || "";
        this.initMonaco();
        this.loadChatbotAttributes();
        window.addEventListener("resize", this.handleResize);
        window.addEventListener("keydown", this.handleKeyDown);
    },
    beforeDestroy() {
        this.destroyMonaco();
        this.cancels.forEach((cancel) => cancel());
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener("keydown", this.handleKeyDown);
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        loadChatbotAttributes() {
            const storyId = this.$route.params.id;
            const board = this.board(storyId);
            
            // Sistem ve özel attribute'ları topla
            const allAttributes = [
                ...systemAttributes.map(x => ({
                    name: x.name,
                    value: x.value,
                    type: "system"
                })),
                ...(board?.state?.attributes || []).map(x => ({
                    name: x,
                    value: x,
                    type: "custom"
                }))
            ];

            this.chatbotAttributes = allAttributes;
        },
        initMonaco() {
            monaco.languages.typescript.javascriptDefaults.setExtraLibs([]);
            monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
                target: monaco.languages.typescript.ScriptTarget.ES6,
                module: monaco.languages.typescript.ModuleKind.CommonJS,
                allowNonTsExtensions: true,
                noLib: true,
            });

            this.editor = monaco.editor.create(document.getElementById("monaco-editor-container-chatbot"), {
                value: this.payload.code,
                language: "javascript",
                theme: "vs-dark",
                minimap: {
                    enabled: false,
                },
                automaticLayout: true,
                scrollBeyondLastLine: true,
                lineNumbers: "on",
                roundedSelection: true,
                cursorStyle: "line",
                wordWrap: "on",
                tabSize: 2,
                fontSize: 14,
                suggestOnTriggerCharacters: true, // Trigger karakterlerde (nokta) öner
                quickSuggestions: {
                    other: true,  // Normal kod yazarken öner
                    comments: false,
                    strings: true,
                },
                quickSuggestionsDelay: 100, // 100ms gecikme ile öner
                acceptSuggestionOnCommitCharacter: true,
                acceptSuggestionOnEnter: "on",
                inlineSuggest: {
                    enabled: true,
                },
                suggest: {
                    showWords: false, // Kelime önerilerini kapat
                    showMethods: true,
                    showFunctions: true,
                    showConstructors: true,
                    showFields: true,
                    showVariables: true,
                    showClasses: true,
                    showStructs: true,
                    showInterfaces: true,
                    showModules: true,
                    showProperties: true,
                    showEvents: true,
                    showOperators: false,
                    showUnits: false,
                    showValues: true,
                    showConstants: true,
                    showEnums: true,
                    showEnumMembers: true,
                    showKeywords: false,
                    showSnippets: true,
                    snippetsPreventQuickSuggestions: false,
                },
                scrollbar: {
                    vertical: 'visible',
                    horizontal: 'visible',
                    useShadows: false,
                    verticalHasArrows: false,
                    horizontalHasArrows: false,
                    verticalScrollbarSize: 10,
                    horizontalScrollbarSize: 10
                },
                overviewRulerLanes: 0,
                hideCursorInOverviewRuler: true,
                overviewRulerBorder: false,
            });

            this.editor.onDidChangeModelContent(() => {
                this.payload.code = this.editor.getValue();
                this.hasUnsavedChanges = this.payload.code !== this.originalCode;
                this.$emit("input", this.payload);
            });

            // Language configuration
            monaco.languages.setLanguageConfiguration("javascript", {
                wordPattern: /(-?\d*\.\d\w*)|([^\`\~\!\@\#\$\%\^\&\*\(\)\=\+\[\{\]\}\\\|\;\:\'\"\,\.\<\>\/\?\s]+)/g,
                comments: {
                    lineComment: "//",
                    blockComment: ["/*", "*/"],
                },
                brackets: [
                    ["{", "}"],
                    ["[", "]"],
                    ["(", ")"],
                ],
                autoClosingPairs: [
                    { open: "{", close: "}" },
                    { open: "[", close: "]" },
                    { open: "(", close: ")" },
                    { open: '"', close: '"' },
                    { open: "'", close: "'" },
                    { open: "`", close: "`" },
                ],
            });

            // Autocomplete provider'ı kaydet
            this.cancels.forEach((disposeFn) => disposeFn());
            this.cancels = [];
            const disposable = monaco.languages.registerCompletionItemProvider(
                "javascript",
                createCompletionItemProviderForChatbot(this.chatbotAttributes, this.moduleCache)
            );
            this.cancels.push(() => disposable.dispose());
        },
        destroyMonaco() {
            if (this.editor) {
                this.editor.dispose();
            }
        },
        handleResize() {
            if (this.editor) {
                this.editor.layout();
            }
        },
        handleKeyDown(e) {
            // Tam ekran modunda ESC ile çık
            if (e.key === "Escape" && this.isFullScreen) {
                this.isFullScreen = false;
                this.$nextTick(() => {
                    if (this.editor) {
                        this.editor.layout();
                    }
                });
            }
        },
        showPromptWizard() {
            this.showJsAssistant = true;
            this.jsPrompt = "";
            this.$nextTick(() => {
                if (this.$refs.promptTextarea) {
                    this.$refs.promptTextarea.focus();
                }
            });
        },
        handleAssistantClose() {
            this.showJsAssistant = false;
        },
        selectExamplePrompt(prompt) {
            this.jsPrompt = prompt;
        },
        wrapTryCatch(fn, defaultReturn = []) {
            try {
                return fn();
            } catch (error) {
                console.error(error);
                return defaultReturn;
            }
        },
        async generateJavaScriptCode() {
            if (!this.jsPrompt.trim()) {
                this.$message.warning("Lütfen bir istek yazın");
                return;
            }

            try {
                this.assistantLoading = true;

                const copilot = CoPilot.getInstance();

                // Chatbot attributes'larını hazırla
                const response = await copilot.generateChatbotJavaScriptCode({
                    siteId: this.$store.state.site.site._id,
                    customerPrompt: this.jsPrompt,
                    chatbotAttributes: this.chatbotAttributes,
                    blockId: this.blockId,
                    storyId: this.$route.params.id,
                    currentCode: this.payload.code,
                    user_list: this.users.map((x) => ({
                        name: x.name,
                        email: x.email,
                        id: x._id,
                        phone: x.phone,
                        isMe: x._id === this.me,
                    })),
                    channel_list: [
                        ...this.wrapTryCatch(
                            () =>
                                this.channels.map((channel) => ({
                                    type: "channel",
                                    id: channel._id,
                                    name: channel.name,
                                    channelType: channel.type,
                                    enabled: channel.enabled,
                                })),
                            []
                        ),
                    ],
                });

                if (response && response.code) {
                    this.editor.setValue(response.code);
                    this.payload.code = response.code;
                    this.$emit("input", this.payload);
                    this.showJsAssistant = false;
                    this.$message.success("JavaScript kodu başarıyla oluşturuldu");
                } else {
                    this.$message.error("Kod oluşturulurken bir hata oluştu");
                }
            } catch (error) {
                console.error("Kod üretme hatası:", error);
                this.$message.error("Kod oluşturulurken bir hata oluştu: " + (error.message || "Bilinmeyen hata"));
            } finally {
                this.assistantLoading = false;
            }
        },
        toggleFullScreen() {
            this.isFullScreen = !this.isFullScreen;
            this.$nextTick(() => {
                if (this.editor) {
                    this.editor.layout();
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.run-javascript {
    .editor-row {
        margin-bottom: 20px;

        .editor-row-title {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 10px;
            color: #22314a;
        }

        .code-editor-wrapper {
            border: 1px solid #e0e0e0;
            border-radius: 8px;
            overflow: hidden;

            .code-editor-header {
                background-color: #f5f7fa;
                padding: 12px 16px;
                border-bottom: 1px solid #e0e0e0;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .tips {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;

                    .tip {
                        display: flex;
                        align-items: center;
                        gap: 6px;
                        font-size: 12px;
                        color: #647283;

                        md-icon {
                            font-size: 16px;
                        }
                    }
                }

                .actions {
                    display: flex;
                    gap: 8px;
                }
            }

            .code-editor {
                .available-libraries,
                .available-variables,
                .attribute-help {
                    padding: 8px 16px;
                    background-color: #fafbfc;
                    border-bottom: 1px solid #e0e0e0;
                    font-size: 12px;
                    color: #647283;

                    span {
                        font-weight: 600;
                        margin-right: 8px;
                    }

                    code {
                        background-color: #fff;
                        padding: 2px 6px;
                        border-radius: 3px;
                        border: 1px solid #e0e0e0;
                        font-family: "Monaco", "Courier New", monospace;
                        font-size: 11px;
                        margin-right: 6px;
                    }
                }

                .monaco-editor-container {
                    height: 400px;
                    width: 100%;

                    &.fullscreen-editor {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        z-index: 10000;
                    }
                }
            }

            .code-restrictions {
                padding: 12px 16px;
                background-color: #fff8e1;
                border-top: 1px solid #ffe082;

                .restriction-title {
                    font-weight: 600;
                    color: #f57c00;
                    margin-bottom: 8px;
                }

                ul {
                    margin: 0;
                    padding-left: 20px;
                    font-size: 12px;
                    color: #647283;

                    li {
                        margin-bottom: 4px;
                    }
                }
            }

            .example-usage {
                padding: 16px;
                background-color: #f5f7fa;

                .example-title {
                    font-weight: 600;
                    margin-bottom: 8px;
                    color: #22314a;
                }

                pre {
                    background-color: #1e1e1e;
                    color: #d4d4d4;
                    padding: 12px;
                    border-radius: 4px;
                    font-size: 12px;
                    line-height: 1.6;
                    overflow-x: auto;
                    font-family: "Monaco", "Courier New", monospace;
                    margin: 0;
                }
            }
        }
    }
}

.js-assistant-modal {
    .js-assistant-description {
        margin-bottom: 20px;

        h4 {
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 8px;
            color: #22314a;
        }

        p {
            color: #647283;
            margin-bottom: 16px;
        }

        .js-capabilities {
            background-color: #f5f7fa;
            border-radius: 8px;
            padding: 16px;
            margin-bottom: 16px;

            .capabilities-header {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 12px;

                h5 {
                    margin: 0;
                    font-size: 14px;
                    font-weight: 600;
                    color: #22314a;
                }
            }

            .capabilities-content {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 8px;

                .capability-item {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 13px;
                    color: #647283;

                    i {
                        font-size: 18px;
                        color: #ff6b35;
                    }
                }
            }
        }
    }

    .prompt-container {
        .example-prompts {
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-top: 12px;
            margin-bottom: 16px;

            .example-prompt {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 8px 12px;
                background-color: #f5f7fa;
                border-radius: 4px;
                cursor: pointer;
                transition: all 0.2s;
                font-size: 13px;
                color: #647283;

                &:hover {
                    background-color: #e8eef3;
                    transform: translateX(4px);
                }

                .anticon {
                    color: #ff6b35;
                }
            }
        }

        .buttons-container {
            display: flex;
            justify-content: flex-end;
            gap: 8px;
            margin-top: 16px;
        }
    }
}
</style>

